import { render, staticRenderFns } from "./ExternalPartnerMappingsSection.vue?vue&type=template&id=67485682&scoped=true&"
import script from "./ExternalPartnerMappingsSection.vue?vue&type=script&lang=js&"
export * from "./ExternalPartnerMappingsSection.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPartnerMappingsSection.vue?vue&type=style&index=0&id=67485682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67485682",
  null
  
)

export default component.exports